import Defines   from './upgrade-defines.es6';

export default {
    events: {
        'buttonClick .upgradePayment__cancel-card': 'onCardCancel',
    },
    onCardCancel (e) {
        e.preventDefault();
        this.doCardCancel();
    },
    doCardCancel () {
        this.clearState(
            'card',
            'card_method',
            'card_data',
            'card_error'
        );
    },
    onCardSuccess (response) {
        this.setInitialState();
    },
    onCardError (response) {
        var html = this.upgrade.formatStripeError(response);
        this.extendState({
            card: 'idle',
            card_method: [this.getPaymentCards()],
            card_error: html,
            card_data: null
        });
    },
    afterPay (response) {
        if (response.success) {
            this.onCardSuccess(response);
        } else {
            this.onCardError(response);
        }
    },
    paymentHandlers: {
        card () {
            this.extendState({
                card: 'waiting',
                card_error: null,
            });
            let afterStripe = (data) => {
                if (data) {
                    this.extendState({
                        card: 'progress',
                        card_data: data,
                    });
                } else {
                    this.doCardCancel();
                }
            };
            switch (this.state.chosen) {
            case Defines.SCHEDULE_MONTHLY_RECURRING:
                this.upgrade.subscribeMonthly(afterStripe);
                break;
            case Defines.SCHEDULE_ANNUAL_ONEOFF:
                this.upgrade.subscribeYearly(false, afterStripe);
                break;
            case Defines.SCHEDULE_ANNUAL_RECURRING:
                this.upgrade.subscribeYearly(true, afterStripe);
                break;
            }
        },
    },
    getPaymentCards () {
        return {
            button: 'Pay with a card',
            methods: [{
                img: '/static/cards/american-express-curved-32px.png',
                label: 'American Express',
                width: 51,
                height: 32
            }, {
                img: '/static/cards/mastercard-curved-32px.png',
                label: 'MasterCard',
                width: 51,
                height: 32
            }, {
                img: '/static/cards/visa-curved-32px.png',
                alt: 'Visa',
                width: 51,
                height: 32
            }],
            value: 'card'
        };
    },
};



// WEBPACK FOOTER //
// ./app/src/view/upgrade-card.es6